/**
* 卡牛
*/

import '@common/polyfill/src/promise'
import useragent from '@finance/useragent'
import clientBridge from '@common/client/src/bridge'
import clientVersion from '@common/client/src/version'

import { callbackHandler } from '../utils'

import BaseAuth from './base'

// 刷新token的次数，防止死循环
let refreshTokenTimes = 3

class CardniuAuth extends BaseAuth {
  constructor(options) {
    super(options)
    if (useragent.isKaniu) {
      // 随手记
      this.isClientHit = true
    }
    this.isRelyOnIsLoginCookie = false
  }
  // 请求卡牛协议
  callClientBridge() {
    const fnRequestLogin = (resolve, reject, uri) => {
      clientBridge.call(uri, 'onLoginResult', (data) => {
        if (data.result) {
          const result = {
            success: data.result || false,
            userName: data.username || null,
            password: data.pwd || null,
            token: data.token || null
          }
          resolve(result)
        } else {
          reject({
            type: 'cancel',
            msg: '取消登录'
          })
        }
      })
    }
    return new Promise((resolve, reject) => {
      // 请求客户端信息
      if (this.loginType.force || this.loginType.normal) {
        fnRequestLogin(resolve, reject, 'cardniu://app/requestLogin')
      } else {
        clientBridge.call('cardniu://api/getUserInfo', 'onGetUserInfo', (dataInfo) => {
          // 模拟静默登录
          if (this.loginType.silent) {
            if (dataInfo.userName) {
              fnRequestLogin(resolve, reject, 'cardniu://app/requestLogin')
            } else {
              const result = {
                success: false,
                userName: null,
                password: null,
                token: null
              }
              resolve(result)
            }
          } else if (this.loginType.tokenExpire) {
            fnRequestLogin(resolve, reject, 'cardniu://app/loginStatusRequest?code=1')
          } else if (this.loginType.tokenError) {
            fnRequestLogin(resolve, reject, 'cardniu://app/loginStatusRequest?code=3')
          } else {
            // 重新登录
            const featureVersion = useragent.isIOS ? '7.7.1' : '7.7.9'
            if (clientVersion.compare(featureVersion, dataInfo.version)) {
              fnRequestLogin(resolve, reject, 'cardniu://app/requestRelogin')
            } else {
              reject({
                type: 'error',
                msg: '登录状态已失效，请重新登录'
              })
            }
          }
        })
      }
    })
  }
  // 处理客户端返回的数据
  async clientDataHandler() {
    const tokenExpire = () => {
      this.resetLoginType('tokenExpire')
      if (refreshTokenTimes > 0) {
        this.login()
        refreshTokenTimes--
      } else {
        console.warn('登录失败', 'Api login Error: refresh times out')
        callbackHandler(this.options.error, { msg: '登录失败，请重试' })
      }
    }
    const tokenError = () => {
      this.resetLoginType('tokenError')
      this.login()
    }
    const accountError = () => {
      this.resetLoginType('force')
      this.login()
    }
    try {
      const clientData = await this.callClientBridge()
      this.requestLoginApi({
        userName: clientData.userName || null,
        password: clientData.password || null,
        token: clientData.token || null,
        loginState: clientData.success || false,
      }, {
        tokenExpire,
        tokenError,
        accountError,
      })
    } catch (error) {
      if (error && error.type === 'cancel') {
        console.log('用户已取消登录')
        callbackHandler(this.options.cancel)
      } else {
        console.error('Cardniu Login Error:', error)
        callbackHandler(this.options.error, { msg: '登录失败，请重试' })
      }
    }
  }
  // 获取token
  getToken() {
    if (!this.isClientHit) return undefined
    return this.callClientBridge().then(({ token }) => {
      // HACK:因静默登录返回数据不明确，先单独处理
      if (token) {
        return { token }
      }
      return {}
    }).catch((error) => {
      console.error('GetToken Error:', error)
      callbackHandler(this.options.error, { msg: '登录失败，请重试' })
    })
  }
  // 登录
  login() {
    if (!this.isClientHit) return
    if (this.checkIsLogin()) {
      this.requestLoginApiSuccessCallback()
    } else {
      this.clientDataHandler()
    }
  }
}

export default CardniuAuth
